import { useLayoutEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import Dialog from "../../../../../../../../components/shared/Dialog";
import Content from "./Content";
import { useScheduleContext } from "../../../../../hooks/context/useScheduleContext";
import { useFilters } from "../../../../../../../../utils/hooks/useFilters";
import { useDailyEventsApi } from "../../../../../api/useDailyEventsApi";
import { useCompanyDateFormat } from "../../../../../../../../utils/hooks/company";

function MoreModal({ selected, open, close }: any) {
    const { t } = useTranslation();
    const dateFormat = useCompanyDateFormat();
    const [page, setPage] = useState(0);
    const [perPage, setPerPage] = useState(50);
    const [filters] = useFilters();
    const { type } = useScheduleContext();

    const params = useMemo(() => {
        const baseParams: any = {
            filters: filters?.filters ?? [],
            sort: filters?.sort,
            excludeShifts: selected?.exclude,
            includeOvernight: false,
            web: true
        };
        if (type === "team") {
            baseParams.page = page;
            baseParams.perPage = perPage;
        }
        return baseParams;
    }, [filters?.filters, filters?.sort, selected?.exclude, type, page, perPage]);

    const { fetchEvents } = useDailyEventsApi();

    // Layout effect: start loading before the modal paints, so it never flashes the previous results
    useLayoutEffect(() => {
        if (open) {
            fetchEvents(selected?.date, params);
        }
    }, [open, fetchEvents, selected?.date, params]);

    return (
        <Dialog
            open={open}
            close={close}
            contentClassName="min-w-xl"
            size="2xl"
            title={(
                <>
                    {t("information")}
                    <span className="tw-text-sm tw-mx-2 tw-text-neutral-500">
                        {"("}{moment(selected?.date).format(dateFormat)}{")"}
                    </span>
                </>
            )}
        >
            <Content
                hiddenEvents={selected?.hiddenEvents || []}
                page={page}
                setPage={setPage}
                perPage={perPage}
                setPerPage={setPerPage}
                close={close}
            />
        </Dialog>
    );
}

export default MoreModal;
